import React from 'react';
import { HashRouter as Router, Route, Switch } from 'react-router-dom';
import MainWrapper from '../MainWrapper';
import NotFound404 from '../../DefaultPage/404/index';
import PndLanding from '../../PnD/Landing';
// import PndInformapAdminLanding from '../../PnD/InformapAdminLanding';
// import PndMerchantLanding from '../../PnD/MerchantLanding';
import PndProtectedRouterIndex from './PnDRouter/PndProtectedRouterIndex';
import MapTracker from '../../../MapTracker';
const AppRouter = () => (
  <Router>
    <MainWrapper>
      <main>
        <Switch>
          <Route exact path="/" component={PndLanding} />
          {/* ⭐ PUBLIC MAP PAGE */}
       <Route exact path="/vehicle-map/:orderNo" component={MapTracker} />

          <Route exact path="/landing_app/" component={PndLanding} />
          <Route path="/404" component={NotFound404} />
          <Route path="/web_app" component={PndProtectedRouterIndex} />
          <Route component={NotFound404} />

        </Switch>
      </main>
    </MainWrapper>
  </Router>
);

export default AppRouter;
